import { useEffect, useRef } from 'react';
import { resolveAssetUrl } from '../api';

export function useAudio(assetUrl) {
  const audioRef = useRef(null);

  useEffect(() => {
    if (assetUrl) {
      audioRef.current = new Audio(resolveAssetUrl(assetUrl));
    }
  }, [assetUrl]);

  return async () => {
    try {
      if (audioRef.current) {
        audioRef.current.currentTime = 0;
        await audioRef.current.play();
      }
    } catch {
      // autoplay can fail silently
    }
  };
}
